export const AD_TYPES_CPM_CONFIG = "AD_TYPES_CPM_CONFIG";
export const RESET_REDUCER_DATA = "RESET_REDUCER_DATA";
